<!--VNEXT-392: KLW - Redo the title to include the suggest permission button-->
<div class="display-split-main">
    <!--VNEXT-439: KLW - Add in styling to only show the suggest permissions button when there are suggested permissions-->
    <div [class.fill-remaining]="this.HasSuggestedPermissions">
    </div>
    <div [ngClass]="this.HasSuggestedPermissions ? 'fill-remaining display-split-main-right' : 'display-split-main-right-noshow'"> 
        <h5 class="title-h">
            Permissions
        </h5>
        <button *ngIf="this.HasSuggestedPermissions && !this.ShowOrHidePropertiesForSimplifiedPermissionsModel"
                mat-raised-button
                class="suggest-button display-split-main-margin"
                (mouseenter)="this.enableClassForSuggest()"
                (mouseleave)="this.disableClassForSuggest()"
                (click)="this.setSuggestedPermissions()"
                matTooltip="{{this.SuggestButtonDescription}}">
            Suggest Permissions
        </button>
    </div>
</div>

<div *ngIf="this.WorkflowPermissionsDataSource !== null"
     class="mat-table-div">
    <table mat-table class="mat-elevation-z4 permissions-mat-table"
           [dataSource]="this.WorkflowPermissionsDataSource"
           multiTemplateDataRows>
        <!-- Define the grid's column definitions. -->
        <ng-container matColumnDef="Role">
            <th mat-header-cell *matHeaderCellDef
                class="role-mat-header-cell">
                Role
            </th>

            <td mat-cell *matCellDef="let permissionRow; let i = index"
                [ngClass]="(this.SimplePermissionNames.length > 1) ? 'role-mat-cell-def' : 'shorter-role-mat-cell-def'">
                {{permissionRow.roleName}}
            </td>
        </ng-container>

        <!--VNEXT-441: KLW - Logic to show the correct Workflow action permission name -->
        <ng-container matColumnDef="Permissions">
            <th mat-header-cell *matHeaderCellDef
                class="permissions-mat-header-cell">
                {{this.PermissionTitle}}
            </th>

            <td mat-cell
                *matCellDef="let permissionsRow; let i = index"
                [ngClass]="(this.SimplePermissionNames.length > 1) ? 'permissions-mat-cell-def' : 'shorter-permissions-mat-cell-def'">

                <mat-checkbox *ngIf="this.IsState"
                              class="mat-checkbox-in-row"
                              [ngClass]="{ 'suggested-permission' : this.showSuggestAnimation(permissionsRow.canView, permissionsRow.suggestCanView)}"
                              [(ngModel)]="permissionsRow.canView">{{this.ViewText}}</mat-checkbox>
                <mat-checkbox *ngIf="this.IsState"
                              class="mat-checkbox-in-row"
                              [ngClass]="{ 'suggested-permission' : this.showSuggestAnimation(permissionsRow.canEdit, permissionsRow.suggestCanEdit)}"
                              [(ngModel)]="permissionsRow.canEdit">{{this.EditText}}</mat-checkbox>
                <mat-checkbox *ngIf="this.IsState && !this.ShowOrHidePropertiesForSimplifiedPermissionsModel"
                              class="mat-checkbox-in-row"
                              [ngClass]="{ 'suggested-permission' : this.showSuggestAnimation(permissionsRow.canDelete, permissionsRow.suggestCanDelete)}"
                              [(ngModel)]="permissionsRow.canDelete">Delete</mat-checkbox>
                <mat-checkbox *ngIf="this.IsState && !this.ShowOrHidePropertiesForSimplifiedPermissionsModel"
                              class="mat-checkbox-in-row"
                              [ngClass]="{ 'suggested-permission' : this.showSuggestAnimation(permissionsRow.canGrant, permissionsRow.suggestCanGrant)}"
                              [(ngModel)]="permissionsRow.canGrant">Grant Permissions</mat-checkbox>
                <mat-checkbox *ngIf="this.IsState && !this.ShowOrHidePropertiesForSimplifiedPermissionsModel"
                              class="mat-checkbox-in-row"
                              [ngClass]="{ 'suggested-permission' : this.showSuggestAnimation(permissionsRow.canBuildFolders, permissionsRow.suggestCanBuildFolders)}"
                              [(ngModel)]="permissionsRow.canBuildFolders">Create Folders</mat-checkbox>
                <mat-checkbox *ngIf="this.IsState && !this.ShowOrHidePropertiesForSimplifiedPermissionsModel"
                              class="mat-checkbox-in-row"
                              [ngClass]="{ 'suggested-permission' : this.showSuggestAnimation(permissionsRow.canBuildFormInstances, permissionsRow.suggestCanBuildFormInstances)}"
                              [(ngModel)]="permissionsRow.canBuildFormInstances">Create Forms</mat-checkbox>

                <!--VNEXT-348: KLW - Changes to where transition changes both canEdit and canView-->
                <mat-checkbox *ngIf="this.IsTransition"
                              class="mat-checkbox-in-row"
                              [(ngModel)]="permissionsRow.canView"
                              (ngModelChange)="this.transitionPermissionChanged(this.IsTransition, permissionsRow.canView, permissionsRow)"></mat-checkbox>

            </td>
        </ng-container>

        <!-- Define the grid's row header. -->
        <mat-header-row *matHeaderRowDef="this.PermissionsGridColumnNames"></mat-header-row>

        <!-- Define the grid's row data. -->
        <mat-row *matRowDef="let row; columns: this.PermissionsGridColumnNames">
        </mat-row>

    </table>
</div>
